
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking/for-self",
      function () {
        return require("private-next-pages/booking/for-self.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/booking/for-self"])
      });
    }
  